<template>
  <extended-entity-edit ref="list"
                        :formConfig="formConfig"
                        :entityId="entityId"
                        :temporaryListToAdd="temporaryListToAdd"
                        :temporaryInstanceToEdit="temporaryInstanceToEdit"
                        :mode="mode"

                        :detailsConfig="detailsConfig"
                        :masterFormConfig="masterFormConfig"
                        :masterId="masterId"
                        :context="context"
                        :masterEntityInstance="masterEntityInstance"

                        :treeParentConfig="treeParentConfig"

                        @entity-instance-loaded="setInstance"
                        @cancel="close"
                        :presetFields="presetFields ? presetFields : ((context && context.presetFields) ? context.presetFields : null)"
                        :show-delete="showDelete"
                        v-model="unsavedChanges"
  >

  </extended-entity-edit>
</template>
<script>
import Perms from "@/server/Perms";
import FormConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormConfig";
import Activity from "@/activity/Activity";
import FormsAI from "@/components/forms/FormsAI";
import ExtendedEntityEdit from "@/components/forms/ExtendedEntityEdit";
import FormDetailsConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig";
import DialogManager from "@/utils/DialogManager";
import TemporaryList from "@/components/forms/TemporaryList"
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import ActivityManager from "@/activity/ActivityManager";


export default {
  name: "ActivityEdit",
  permission: null,
  components: {ExtendedEntityEdit},
  async beforeMount() {
    this.permission = this.formConfig.restrictedList ? Perms[this.formConfig.effectivePermissionRead] : null;
  },

  async mounted() {
    //console.log(this.treeParentRecord)
    this.activity = ActivityManager.findActivity(this.$el);

    if(window['_mem_bombs']) {
      this.bomb = new ArrayBuffer(50 * 1024 * 1024);
      console.log("Bomb!!!!");
    }
  },

  methods: {
    ...Activity.methods,

    setInstance(instance){
      this.instance = instance;
      this.title = FormsAI.getEntityLabel(this.formConfig, instance);
    },

    /**
     * @param form {FormModel}
     */
    masterFormSet(form){
      this.$emit("update:form", form);
      this.$emit("form-created", form);
      form.onChange(() => {
        this.activity?.refreshTitle();
      });
      this.activity?.refreshTitle();
    },
    getTitle() {
      if (this.mode === "NEW") {
        return $tr("activity.new", "New #{1}", this.formConfig.entityName);
      } else {
        this.title = FormsAI.getEntityLabel(this.formConfig, this.instance);
        return this.title;
      }
    },

    beforeClose() {
      if(this.instance){
        this.setResult(this.instance);
      }
    },

    async close(){
      let wnd = this.$refs.list;
      if(wnd.willReopen()){
        let res = await ActivityManager.closeTopActivityForReopen();
        wnd?.activityClosed?.();
        return res;
      }
      let res = await ActivityManager.closeTopActivity();
      wnd?.activityClosed?.();
      return res;
    },

    cancel() {
      this.close();
    },

    async canClose(){
      return this.$refs.list.canClose();
    }
  },

  props: {
    masterEntityInstance: {default: null},
    formConfig: {type: BaseFormConfig, default: ""},
    entityId: {type: String, default: ""},
    mode: {type: String, default: null},

    detailsConfig: {type: FormDetailsConfig, default: null},
    masterFormConfig: {type: BaseFormConfig, default: null},
    masterId: {type:String, default: null},
    temporaryListToAdd: {type:TemporaryList, default:null },
    temporaryInstanceToEdit : {default:null},
    treeParentConfig: {default: null},
    presetFields: {default: null},
    context: {default:null},
    showDelete: {default: true}
  },

  data: () => ({
    instance: null,
    title: '',
    unsavedChanges: false
  }),
}
</script>
